import * as d3 from "d3";
import { interpolateHslLine, interpolateOkhsl } from "../interpolate/index.js";
import { okhsl } from "./okhsl.js";
import { Color, isColorInstance, isCuloriLike, isHslLike } from "./color.js";
import { toRGB } from "./helpers.js";
import { hsluv } from "./hsluv.js";
import { converter, formatRgb, } from "culori";
export const LEGACY_DATA_COLOR_PALETTE = [
    { h: 7, s: 1.0, l: 0.36, opacity: 1.0 },
    //  { h: 22, s: 0.9, l: 0.45, opacity: 1.0 },
    //  { h: 45, s: 0.98, l: 0.45, opacity: 1.0 },//this one goes to almost white with a call to brighter()
    { h: 45, s: 0.98, l: 0.38, opacity: 1.0 },
    { h: 115, s: 0.98, l: 0.3, opacity: 1.0 },
    { h: 187, s: 0.95, l: 0.38, opacity: 1.0 },
    { h: 208, s: 1.0, l: 0.36, opacity: 1.0 },
    { h: 296, s: 0.9, l: 0.34, opacity: 1.0 },
];
export const LEGACY_ODOUR_MODELLING_MAP = [
    //  { value: 0, color: { hue: 0, saturation: 0, lightness: 100, alpha: 0 } },
    { value: 0.5, color: { hue: 240, saturation: 0, lightness: 89, alpha: 0.3 } },
    { value: 1, color: { hue: 240, saturation: 40, lightness: 20, alpha: 0.8 } },
    { value: 10, color: { hue: 0, saturation: 80, lightness: 60, alpha: 0.8 } },
];
const LEGACY_MONO_HUE_SATURATION_PROFILE = [
    0.0, 0.75, 0.52, 0.46, 0.59, 0.7, 0.77, 0.76, 1.0, 1.0,
];
const LEGACY_MONO_HUE_LIGHTNESS_PROFILE = [
    1.0, 0.95, 0.86, 0.73, 0.66, 0.57, 0.46, 0.38, 0.25, 0.2,
];
export const LEGACY_DATA_COLOR_INTERPOLATOR = (interpolatorFactory) => d3.piecewise(interpolatorFactory ?? d3.interpolateHsl, LEGACY_DATA_COLOR_PALETTE.concat([LEGACY_DATA_COLOR_PALETTE[0]]).map((c) => d3.hsl(c.h, c.s, c.l, c.opacity).formatHex()));
export const legacyMonoHuePalette = (hue) => LEGACY_MONO_HUE_SATURATION_PROFILE.map((s, i) => ({
    h: hue,
    s: s,
    l: LEGACY_MONO_HUE_LIGHTNESS_PROFILE[i],
    opacity: 1.0,
}));
export const legacyMonoHuePaletteInterpolator = (hue, interpolatorFactory) => d3.piecewise(interpolatorFactory ?? d3.interpolateHsl, legacyMonoHuePalette(hue).map((c) => d3.hsl(c.h, c.s, c.l, c.opacity).formatHex()));
export const mapToRgbString = (c) => {
    if (isColorInstance(c)) {
        return c.toString();
    }
    else if (isHslLike(c)) {
        const h = c.h;
        const s = c.s;
        const l = c.l;
        const opacity = c.opacity;
        const mode = c.mode;
        switch (mode) {
            case "hsl":
                return d3.hsl(h, s, l, opacity).toString();
            case "okhsl":
                return okhsl(h, s, l, opacity).toString();
            case "hsluv":
                return hsluv(h, s, l, opacity).toString();
            default:
                return d3.hsl(h, s, l, opacity).toString();
        }
    }
    else if (isLegacyColorLike(c)) {
        const h = c.hue;
        const s = c.saturation / 100;
        const l = c.lightness / 100;
        const opacity = c.alpha;
        const mode = c.mode;
        switch (mode) {
            case "hsl":
                return d3.hsl(h, s, l, opacity).toString();
            case "okhsl":
                return okhsl(h, s, l, opacity).toString();
            case "hsluv":
                return hsluv(h, s, l, opacity).toString();
            default:
                return d3.hsl(h, s, l, opacity).toString();
        }
    }
    else if (isCuloriLike(c)) {
        return formatRgb(c);
    }
    else {
        //last resort
        const tcRgb = toRGB(c);
        return d3.rgb(tcRgb.r, tcRgb.g, tcRgb.b, tcRgb.a).toString();
    }
};
const isLegacyColorLike = (o) => {
    return (!!o &&
        typeof o.hue === "number" &&
        typeof o.saturation === "number" &&
        typeof o.lightness === "number" &&
        (typeof o.alpha === "number" ||
            typeof o.alpha === "undefined"));
};
export const LEGACY_ODOUR_MODELING_SCALE = (noAlpha = false) => !noAlpha
    ? d3
        .scaleLinear(LEGACY_ODOUR_MODELLING_MAP.map(entry => entry.value), LEGACY_ODOUR_MODELLING_MAP.map(entry => mapToRgbString(entry.color)))
        .interpolate(d3.interpolateHslLong)
        .clamp(true)
    : d3
        .scaleLinear(LEGACY_ODOUR_MODELLING_MAP.slice(0).map(entry => entry.value), LEGACY_ODOUR_MODELLING_MAP.slice(0)
        .map((entry) => Object.assign({}, entry.color, { alpha: 1.0 }))
        .map((color) => mapToRgbString(color)))
        .interpolate(d3.interpolateHslLong)
        .clamp(true);
